import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import VehicleContextProvider from './Components/Context/VehicleContext';
import UserContextProvider from './Components/Context/UserContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <VehicleContextProvider>
    <UserContextProvider>
      <App />
    </UserContextProvider>
  </VehicleContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
